"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalNav = GlobalNav;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var router_1 = require("next/router");
var styled_components_1 = require("styled-components");
var baseTheme_1 = __importDefault(require("@greatmindsorg/atomic-ui-lib-lts/dist/themes/baseTheme"));
var state_1 = require("./state");
var service_1 = require("./service");
var url_1 = require("./url");
var GlobalNav_styled_1 = require("./GlobalNav.styled");
function GlobalNav(props) {
    var _a, _b;
    var router = (0, router_1.useRouter)();
    var protectedRoutes = (props === null || props === void 0 ? void 0 : props.isStudent) ? ['/home', '/library', '/reports'] : [];
    var globalNav = (0, state_1.useGlobalNav)();
    var redirect = (0, url_1.useGlobalNavRedirect)(protectedRoutes).redirect;
    var _c = (0, url_1.useGlobalNavUrl)(), appendCurricula = _c.appendCurricula, selectByUrl = _c.selectByUrl, BASE_PATH = _c.BASE_PATH;
    var service = (0, service_1.useGlobalNavService)({
        onSuccess: function (apps) {
            var selectedByUrl = selectByUrl(apps);
            var firstValidItem = apps.find(function (app) { return app.redirectionUrl.startsWith(BASE_PATH); });
            var defaultSelected = selectedByUrl || firstValidItem;
            globalNav.select(defaultSelected);
            appendCurricula(defaultSelected === null || defaultSelected === void 0 ? void 0 : defaultSelected.id);
        },
        isStudent: props.isStudent,
    });
    var items = service.data.map(function (item) {
        if (item.redirectionUrl.startsWith(BASE_PATH)) {
            return __assign(__assign({}, item), { redirectionUrl: null });
        }
        return item;
    });
    var onSelect = function (app) {
        var _a;
        redirect(app);
        (_a = props === null || props === void 0 ? void 0 : props.onSelect) === null || _a === void 0 ? void 0 : _a.call(props, app);
    };
    (0, react_1.useEffect)(function () {
        if (!service.data.length)
            return;
        var defaultSelected = service.data.find(function (app) { var _a, _b; return app.id === ((_b = (_a = router === null || router === void 0 ? void 0 : router.query) === null || _a === void 0 ? void 0 : _a.curriculaCode) === null || _b === void 0 ? void 0 : _b.toString().toLowerCase()); });
        if (defaultSelected)
            globalNav.select(defaultSelected);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = service.data) === null || _a === void 0 ? void 0 : _a.length, (_b = router === null || router === void 0 ? void 0 : router.query) === null || _b === void 0 ? void 0 : _b.curriculaCode]);
    var goToHome = function () { var _a; return router.push('/', { query: { curriculaCode: (_a = globalNav.selected) === null || _a === void 0 ? void 0 : _a.id } }); };
    return ((0, jsx_runtime_1.jsx)(styled_components_1.ThemeProvider, { theme: baseTheme_1.default, children: (0, jsx_runtime_1.jsxs)(GlobalNav_styled_1.StyledGlobalNavigation, { mainContentId: props.mainContentId, children: [(0, jsx_runtime_1.jsx)(GlobalNav_styled_1.StyledGlobalNavigation.Logo, { handleOnClick: goToHome, href: "#" }), (0, jsx_runtime_1.jsx)(GlobalNav_styled_1.StyledGlobalNavigation.AppSwitcher, { onSelect: onSelect, failed: service.hasError, items: items, defaultSelected: globalNav.selected, shouldUpdateDefaultSelected: true }), props.children] }) }));
}
